import React from 'react';
import { Box, Flex, Alert, Skeleton } from '@televet/kibble-ui';
import { getMonetaryDisplayValue } from 'shared/utils';

interface IBalanceDisplay {
  ARBalance: number;
  balanceTerminology: string;
  handleSelectBalance: () => void;
  isBalanceSelected: boolean;
  validationMessage: string;
  showSkeleton?: boolean;
}

const BalanceDisplay = ({
  ARBalance,
  balanceTerminology,
  handleSelectBalance,
  isBalanceSelected,
  validationMessage,
  showSkeleton,
}: IBalanceDisplay): JSX.Element => {
  return (
    <>
      <Flex
        fontSize="sm"
        fontWeight="bold"
        alignItems="center"
        my={2}
        justifyContent="space-between"
        p={2}
        borderRadius="md"
        borderWidth={1.5}
        cursor="pointer"
        borderColor={isBalanceSelected ? 'border.focus' : 'border.default'}
        onClick={handleSelectBalance}
      >
        <Skeleton isLoaded={!showSkeleton}>
          <Box>{balanceTerminology}</Box>
        </Skeleton>
        <Skeleton isLoaded={!showSkeleton}>
          <Flex fontSize="lg" fontWeight="bold" mr={2}>
            {getMonetaryDisplayValue(ARBalance, true)}
          </Flex>
        </Skeleton>
      </Flex>
      {!!validationMessage && <Alert title={validationMessage} status="error" hideCloseButton mt={4} mb={3} mr={2} />}
    </>
  );
};

export default BalanceDisplay;
